import '../../CommonStyles.scss';
import SourceBadge from '../SourceBadge/SourceBadge';
import { DataSource } from 'types/admin/analytics';

export const CardHeader = ({ title, badges }: { title: string; badges: DataSource[] }) => {
  return (
    <div className='analytics-card__title-group'>
      <span className='card-title'>{title}</span>
      {badges.map((badge) => (
        <SourceBadge key={badge} source={badge} />
      ))}
    </div>
  );
};
